import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import Cookies from "js-cookie";
import { setStatusFail } from "../statusFail/statusFailSlice";
const initialState = {
  isLoading: false,
  error: null,
  packages: [],
  totalPages: 1,
  singlePackage:null
 
};

const ADMIN_URL = process.env.REACT_APP_ADMIN_URL;

export const createPackage = createAsyncThunk(
  "package/createPackage",
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const response = await axios.post(`${ADMIN_URL}/package`, data, {
        headers: {
          Authorization: `Bearer ${Cookies.get("Token")}`,
        },
      });
      return response.data.data;
    } catch (error) {
      if (error.response?.data?.errorCode == "STATUS_CHECK_TENANT_DENIED") {
        const route = "/status-failed";
        await dispatch(
          setStatusFail({
            tenants: error.response.data.tenants,
            navigate: route,
          })
        );
      }
      return rejectWithValue(
        error.response?.data?.error?.message || "Something went wrong"
      );
    }
  }
);

export const getPackages =createAsyncThunk(
  "package/getPackages",
  async({page,limit,sortBy,order,locationId},{rejectWithValue,dispatch})=>{
    try {
      const resposne = await axios.get(`${ADMIN_URL}/package?page=${page}&limit=${limit}&sortBy=${sortBy}&order=${order}`, {
        headers: {
          Authorization: `Bearer ${Cookies.get("Token")}`,
          tenantId: Cookies.get("TenantId"),
          ...(locationId ? { "location-id": locationId } : {}),
        },
      })
  
      return resposne.data.data
    } catch (error) {
      if(error.response?.data?.errorCode == "STATUS_CHECK_TENANT_DENIED"){
        const route = "/status-failed"
        await dispatch(setStatusFail({tenants:error.response.data.tenants,navigate:route}))
      }
      return rejectWithValue(error.response?.data?.error?.message || "Something went wrong");
    }
}
)

export const getPackageById = createAsyncThunk(
  "package/getPackageById",
  async (id, { rejectWithValue,dispatch }) => {
    try {
      const response = await axios.get(`${ADMIN_URL}/package/${id}`,{
        headers: {
          Authorization: `Bearer ${Cookies.get("Token")}`,
        },
      });
     
      return response.data.data;
    } catch (error) {
      if(error.response?.data?.errorCode == "STATUS_CHECK_TENANT_DENIED"){
             const route = "/status-failed"
             await dispatch(setStatusFail({tenants:error.response.data.tenants,navigate:route}))
           }
           return rejectWithValue(error.response?.data?.error?.message || "Something went wrong");
    }
  }
);

export const updatePackage = createAsyncThunk(
  "package/updatePackage",
  async ({ id, data }, { rejectWithValue ,dispatch}) => {
    try {
      const response = await axios.patch(`${ADMIN_URL}/package/${id}`, data, {
        headers: {
          Authorization: `Bearer ${Cookies.get("Token")}`,
        },
      });
      
      return {id:id,data};
    } catch (error) {
        if(error.response?.data?.errorCode == "STATUS_CHECK_TENANT_DENIED"){
            const route = "/status-failed"
            await dispatch(setStatusFail({tenants:error.response.data.tenants,navigate:route}))
          }
          return rejectWithValue(error.response?.data?.error?.message || "Something went wrong");
    } 
}
);

const packageSlice = createSlice({
  name: "package",
  initialState,
  reducers: {
    clearPackageError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createPackage.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(createPackage.fulfilled, (state, action) => {
        state.isLoading = false;
        // state.packages.push(action.payload);
      })
      .addCase(createPackage.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(getPackages.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getPackages.fulfilled, (state, action) => {
        state.isLoading = false;
        state.packages = action.payload.data;
        state.totalPages = action.payload.totalPages;
      })
      .addCase(getPackages.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(getPackageById.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getPackageById.fulfilled, (state, action) => {
        state.isLoading = false;
        state.singlePackage = action.payload;
      })
      .addCase(getPackageById.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(updatePackage.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updatePackage.fulfilled, (state, action) => {
        state.isLoading = false;
        const index = state.packages.findIndex(
          (pack) => pack._id === action.payload.id
        );
        if (index !== -1) {
          state.packages[index] = {
            ...state.packages[index],
            ...action.payload.data,
          };
        }
      })
      .addCase(updatePackage.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      ;
  },
});

export const { clearPackageError } = packageSlice.actions;

export default packageSlice.reducer;
